export default "__VITE_ASSET__CC6Y2DPD__"